module.exports = __webpack_public_path__ + "static/img/6585_phase_function_Paper_Points.759e74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6585_phase_function_Paper_Points.png
// module id = lV2P
// module chunks = 0